export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recherche"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour sélectionner les colonnes à afficher"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colonnes affichées"])}
}